import { render, staticRenderFns } from "./UrunSatisFiyatPeriyotBaslikModal.vue?vue&type=template&id=1c697a83&scoped=true"
import script from "./UrunSatisFiyatPeriyotBaslikModal.vue?vue&type=script&lang=js"
export * from "./UrunSatisFiyatPeriyotBaslikModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c697a83",
  null
  
)

export default component.exports